import { render, staticRenderFns } from "./StrategyContent.vue?vue&type=template&id=2f885d91&scoped=true"
import script from "./StrategyContent.vue?vue&type=script&lang=js"
export * from "./StrategyContent.vue?vue&type=script&lang=js"
import style0 from "./StrategyContent.vue?vue&type=style&index=0&id=2f885d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f885d91",
  null
  
)

export default component.exports